// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2kFMU","savePackageButton":"ClientWallet_savePackageButton__1S6vq"};